import type { JSX } from 'react';

import RevvlyMark from './revvly-loader.svg?react';

import styles from './LoadingIndicator.module.css';

export default function LoadingIndicator(): JSX.Element {
  return (
    <div className={styles.LoadingIndicator}>
      <RevvlyMark />
    </div>
  );
}
